import React from 'react';
import { css } from '../styled-system/css/index';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const wrapperStyle = css({
  position: 'sticky',
  top: 0,
  bg: '#fff',
  borderBottom: '1px solid #e5e7eb',
  zIndex: 100,
});

const barStyle = css({
  maxW: '1200px',
  m: '0 auto',
  p: '12px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '18px',
  selectors: {
    '@media (max-width: 640px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '8px',
    },
  },
});

const brandStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
  color: '#111827',
  fontWeight: 800,
  textDecoration: 'none',
});

const logoStyle = css({
  h: '28px',
  w: 'auto',
});

const linksStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '18px',
  flexWrap: 'wrap',
  selectors: {
    '@media (max-width: 640px)': {
      justifyContent: 'space-between',
      gap: '8px',
    },
  },
});

const itemStyle = css({
  color: '#111827',
  textDecoration: 'none',
  fontWeight: 600,
  p: '6px 2px',
  borderBottom: '2px solid transparent',
  _hover: {
    color: '#197bbd',
  },
  selectors: {
    '&.active': {
      color: '#197bbd',
      borderColor: '#197bbd',
    },
  },
});

const Nav = () => {
  const { items } = useCart();
  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <header className={wrapperStyle}>
      <div className={barStyle}>
        <Link className={brandStyle} to="/" aria-label="EZIBLANK USA">
          <img className={logoStyle} src="/logo.svg" alt="EZIBLANK USA" />
        </Link>
        <nav className={linksStyle}>
          <NavLink className={itemStyle} to="/" end>Home</NavLink>
          <NavLink className={itemStyle} to="/products">Products</NavLink>
          <NavLink className={itemStyle} to="/contact">Contact</NavLink>
          <NavLink className={itemStyle} to="/cart">Cart({count})</NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Nav;
